import { render, staticRenderFns } from "./IconTileGrid.vue?vue&type=template&id=4b7794ed"
import script from "./IconTileGrid.vue?vue&type=script&lang=js"
export * from "./IconTileGrid.vue?vue&type=script&lang=js"
import style0 from "./IconTileGrid.vue?vue&type=style&index=0&id=4b7794ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports